import React from "react";
import { Login } from "react-admin";

export const MyLoginPage = () => <Login backgroundImage="/bg_login.png" />;
